'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _unionClassNames = require('union-class-names');

var _unionClassNames2 = _interopRequireDefault(_unionClassNames);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DividerButton = function (_Component) {
  _inherits(DividerButton, _Component);

  function DividerButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DividerButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DividerButton.__proto__ || Object.getPrototypeOf(DividerButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
      event.preventDefault();

      var editorState = _this.props.getEditorState();
      var newEditorState = _this.props.addDivider(editorState);

      _this.props.setEditorState(newEditorState);
    }, _this.preventBubblingUp = function (event) {
      event.preventDefault();
    }, _this.blockTypeIsActive = function () {
      var editorState = _this.props.getEditorState();
      var type = editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getStartKey()).getType();
      return type === _this.props.blockType;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DividerButton, [{
    key: 'render',
    value: function render() {
      var theme = this.props.theme;

      var className = this.blockTypeIsActive() ? (0, _unionClassNames2.default)(theme.button, theme.active) : theme.button;

      return _react2.default.createElement(
        'div',
        { className: theme.buttonWrapper, onMouseDown: this.preventBubblingUp },
        _react2.default.createElement(
          'button',
          { className: className, onClick: this.onClick, type: 'button' },
          _react2.default.createElement(
            'svg',
            {
              height: '24',
              viewBox: '0 0 24 24',
              width: '24',
              xmlns: 'http://www.w3.org/2000/svg'
            },
            _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
            _react2.default.createElement('path', { d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
          )
        )
      );
    }
  }]);

  return DividerButton;
}(_react.Component);

DividerButton.propTypes = {
  theme: _propTypes2.default.object,
  getEditorState: _propTypes2.default.func.isRequired,
  setEditorState: _propTypes2.default.func.isRequired,
  addDivider: _propTypes2.default.func.isRequired
};

DividerButton.defaultProps = {
  theme: {}
};

exports.default = DividerButton;